export default function Footer(){
    return(
        <div className="footer">
            <hr/>
            <h3>Built with ❤️ by Varinder Dhillon</h3>

        </div>
    )
}